/* tslint:disable */
/* eslint-disable */
/**
 * Statistics API
 * API for retrieving dashboard statistics (goals, charts, market data)
 *
 * The version of the OpenAPI document: 2.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Type of chart to render (1 Bar, 2 Line, 3 Pie, 4 Doughnut, 5 Area, 6 StackedBar)
 * @export
 */
export const ChartTypeEnum = {
    Bar: 1,
    Line: 2,
    Pie: 3,
    Doughnut: 4,
    Area: 5,
    StackedBar: 6
} as const;
export type ChartTypeEnum = typeof ChartTypeEnum[keyof typeof ChartTypeEnum];


export function instanceOfChartTypeEnum(value: any): boolean {
    for (const key in ChartTypeEnum) {
        if (Object.prototype.hasOwnProperty.call(ChartTypeEnum, key)) {
            if (ChartTypeEnum[key as keyof typeof ChartTypeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChartTypeEnumFromJSON(json: any): ChartTypeEnum {
    return ChartTypeEnumFromJSONTyped(json, false);
}

export function ChartTypeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChartTypeEnum {
    return json as ChartTypeEnum;
}

export function ChartTypeEnumToJSON(value?: ChartTypeEnum | null): any {
    return value as any;
}

export function ChartTypeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): ChartTypeEnum {
    return value as ChartTypeEnum;
}

